import React from "react";
import styles from "./favorites.module.scss";
import { INode } from "../../search/types";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { Box, Card, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { actionCreator } from "../../nodeDetails/nodeDetails.reducer";
import { IDomain } from "../models/userInfo";
import { IFavorite } from "../types";
import { ReactComponent as ApartmentIcon } from "../images/ApartmentIcon.svg";
import { useTranslation } from "react-i18next";
import { Favorite } from "common/components/Favorite";

export interface IFavoriteState {
  favorites: IFavorite[];
  selectedDomain: IDomain | null;
}

const getFavorites = createSelector(
  (state: IApplicationState) => state.common,
  (items) => ({
    favorites: items.favorites,
    selectedDomain: items.selectedDomain,
  })
);

export const Favorites = () => {
  const { favorites, selectedDomain } = useSelector(getFavorites);
  const dispatch = useDispatch();
  const history = useHistory();

  const navigateToObject = (node: INode) => {
    dispatch(actionCreator.setSelectedNode(node));
    history.push(`${selectedDomain?.Code}/safetySensors/${node.ID}`);
  };

  const { t } = useTranslation();
  return (
    <Box sx={{ mt: 2, mb: 2, overflow: "auto" }}>
      <Box
        sx={{
          display: "flex",
          ml: 2,
          mb: 1,
          alignItems: "center",
          gridGap: 8,
        }}
      >
        <ApartmentIcon
          height={30}
          width={30}
          fill="#c7c7c7"
          className={styles.apartmentLogo}
        />
        <Typography variant="h1">{t("Your saved searches:")}</Typography>
      </Box>
      <Box
        sx={{
          margin: 16,
          display: "flex",
          flexDirection: "column",
          gridGap: 16,
        }}
      >
        {favorites
          .filter((f) => f.domain.Name === selectedDomain?.Name)
          .map((x) => (
            <Card
              onClick={() => navigateToObject(x.node)}
              key={`fav-${x.node.ID}`}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography>
                  {x.node.NodeType.Name} {x.node.ObjectNumber}
                </Typography>
                <Favorite selectedNode={x.node} />
              </Box>
            </Card>
          ))}
      </Box>
    </Box>
  );
};
